import { REHYDRATE } from 'redux-persist';
import { createListenerMiddleware } from '@reduxjs/toolkit';

import { AppStartListening } from 'App/ListenerMiddleware';
import refDataApi from './service';

const listenerMiddleware = createListenerMiddleware();
const startAppListening = listenerMiddleware.startListening as AppStartListening;

startAppListening({
  predicate: (action) => (action.type === REHYDRATE),
  effect: async (_, { dispatch }) => {
    dispatch(refDataApi.endpoints.getConfig.initiate());
    dispatch(refDataApi.endpoints.getWorkflows.initiate());
  },
});

export default listenerMiddleware;
